// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_dxA","cls2":"CoScientistPricingPage-cls2_08G CoScientistPricingPage-cls1_dxA"};